import { render, staticRenderFns } from "./BotPartBubble.vue?vue&type=template&id=3f65a33b&scoped=true"
import script from "./BotPartBubble.vue?vue&type=script&lang=js"
export * from "./BotPartBubble.vue?vue&type=script&lang=js"
import style0 from "./BotPartBubble.vue?vue&type=style&index=0&id=3f65a33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65a33b",
  null
  
)

export default component.exports